// extracted by mini-css-extract-plugin
module.exports = {"description":"zVNXuPyDPCNL6CN4wPjX5"};